import styled, { css } from 'styled-components';

const Container = styled.div`
	max-width: 1130px;
	margin-left: auto;
	margin-right: auto;

	@media (max-width: 1180px) {
		max-width: initial;
		padding-left: 25px;
		padding-right: 25px;
	}

	@media (max-width: 768px) {
		padding-left: 15px;
		padding-right: 15px;
	}
`;

// For those times you want to fill the container
export const defeatContainer = css`
	@media (max-width: 1180px) {
		margin-left: -25px;
		width: calc(100% + 50px);
	}

	@media (max-width: 768px) {
		margin-left: -15px;
		width: calc(100% + 30px);
	}
`;

// But you also want the inner stuff inside there
// to look like they're inside the container
// #design :sunglasses:
export const padContainer = css`
	@media (max-width: 1180px) {
		padding-left: 25px;
	}

	@media (max-width: 768px) {
		padding-left: 15px;
	}
`;

export default Container;
